<template>
  <div>
    <div class='pag-header mb-2 p-1'>
      <h3 class="text-right text-white mr-3">Detalhes da Obra</h3>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-6 mt-4 mb-5">
          <h5 class="text-dark">OBRA</h5>
          <h6>{{obras.o01_objeto}}</h6>
        </div>
      </div>
      <div class="row">

        <div class="col-5">
          <h6 class="text-dark">FOTOS DAS MEDIÇÕES DA OBRA</h6>
          <slick
            :options="slickOptions"
            ref="slick"
            @afterChange="handleAfterChange"
            id="slickSlider"
            :hidden="imagem.length <= 1"
          >
            <div v-for="(imagens, i) in imagem" :key="i">
              <img :src="url + 'assets/SistObras/' + imagens.img" @click="abreFoto(i)">
            </div>
          </slick>
          <div v-for="(imagens, i) in imagem" :key="i" v-if="imagem.length <= 1">
            <div @click="abreFoto(i)" id="imagem" style="width: 100%;cursor: pointer;height: 400px;background-size: cover;background-position: center"></div>
            <br>
          </div>
          <div>
            {{desc}} 
            <p v-show="desc.length > 0">Data da medição: {{dat.split('-').reverse().join('/')}}</p>
          </div>
          <div>
            <slickFancy hidden="true"
              :options="slickOptions"
              ref="slickfancy"
              id="slick-fancy"
            >
              <div class="text-center" v-for="(imagens, i) in imagem" :key="i">
                <img class="imagem-tabela"
                     :src="url + 'assets/SistObras/' + imagens.img" height="110px"  :id="'imagem' + i">
              </div>
            </slickFancy>
          </div>
        </div>
        <div class="col-7">
          <h6 class="text-dark">SITUAÇÃO DA OBRA</h6>
          <div class="bg-success text-white mb-4 text-center rounded" v-if="typeof obras.situacao != 'undefined'">
            {{obras.situacao.c04_descr}}
          </div>

          <h6 class="text-dark">DESCRIÇÃO DA OBRA:</h6>

          <p class="mb-4">{{obras.o01_descricao}}</p>
          <div class="row">
            <div class="col-7">
              <div class="text-center">
                <h6>INÍCIO</h6>
                <span style='color:#255595; font-size: 1.2rem;'>{{obras.o01_dt_inicio}}</span>
              </div>
            </div>
            <div class="col-3">
              <div class="text-center">
                <h6>CONCLUSÃO</h6>
                <span style='color:#255595; font-size: 1.2rem;'>{{obras.o01_dt_conclusao}}</span>
              </div>
            </div>
          </div>
          <div class="border p-4 mt-3 mb-4">
            <h6 class="text-center text-dark">DETALHES DA OBRA</h6>
            <div class="row" v-if="obras.area || obras.tipo_obra || obras.tipo_execucao">
              <p class="col-12"><strong>NÚMERO:</strong> {{obras.o01_numero}}</p>
              <p class="col-12"><strong>OBJETO: </strong>{{obras.o01_objeto}}</p>
              <p class="col-12"><strong>ÁREA: </strong>{{obras.area.c03_descr}}</p>
              <p class="col-12"><strong>TIPO DE OBRA: </strong>{{obras.tipo_obra.c01_descr}}</p>
              <p class="col-12"><strong>TIPO DE EXECUÇÃO: </strong>{{obras.tipo_execucao.c06_descr}}</p>
              <p class="col-12"><strong>VALOR: R$ </strong>{{obras.o01_valor}}</p>
              <p class="col-12"><strong>NÚMERO ART: </strong>{{obras.o01_art}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
    import {mapState} from "vuex"
    import slick from 'vue-slick';
    import slickFancy from 'vue-slick';

    const axios = require('axios');

    export default {
        name: 'DetalheObra',
        props: {
            id: String | Number
        },
        components: {
            slick,
            slickFancy
        },
        data() {
            return {
                obras: {},
                imagem: [],
                url: this.$store.state.api,
                desc: '',
                dat: '',
                para: false,
                slickOptions: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: false,
                    cssEase: 'linear',
                    variableWidth: true,
                    variableHeight: true,
                },
            }
        },
        methods: {
            handleAfterChange(event, slick, currentSlide) {
                this.para = true;
                this.desc = this.imagem[currentSlide].serv == null ? '' : this.imagem[currentSlide].serv;
                this.dat = this.imagem[currentSlide].ref == null ? '' : this.imagem[currentSlide].ref.substr(0, 10).split('-').reverse().join('/');
            },

            abreFoto(index){
                $('#imagem'+index).click();
            }
        },
        computed: mapState(['api']
        ),
        beforeUpdate() {
            if (this.$refs.slick && !this.para && this.imagem.length > 1) {
                this.$refs.slick.destroy();
            }

            if (this.$refs.slickfancy && !this.para){
                this.$refs.slickfancy.destroy();
            }
        },
        updated() {
            this.$nextTick(function () {
                $('#imagem').css("background-image", 'url("'+this.url + 'assets/SistObras/' + this.imagem[0].img+'")');


                if (this.$refs.slick && !this.para && this.imagem.length > 1) {
                    this.$refs.slick.create(this.slickOptions);
                }

                if (this.$refs.slickfancy && !this.para){
                    this.$refs.slickfancy.create(this.slickOptions);
                }

                if(!this.para) {
                    $('.slick-prev').click();
                }
            });
        },
        created() {
            axios
                .get(this.api + "obras-cidadao/obras/" + this.id)
                .then(response => {
                    this.obras = response.data;
                    if(typeof this.obras.medicao[0] != 'undefined')
                      this.desc = this.obras.medicao[0].o03_descr_serv;
                      this.dat = this.obras.medicao[0].o03_refer;

                    for (let i = 0; i < this.obras.medicao.length; i++) {
                        for (let j = 0; j < this.obras.medicao[i].obra_fotos.length; j++) {
                            if(j == 0)
                                this.desc = this.obras.medicao[i].o03_descr_serv

                            this.imagem.push({
                                img: this.obras.medicao[i].obra_fotos[j].o02_path_img,
                                serv: this.obras.medicao[i].o03_descr_serv,
                                ref: this.obras.medicao[i].o03_refer
                            })
                        }
                    }
                })
        },
        mounted() {
            let thisVue = this;
            $().fancybox({
                selector: '#slick-fancy .slick-slide',
                afterShow: function (instance, current) {
                    if(thisVue.imagem.length > 1)
                        thisVue.$refs.slick.goTo(parseInt(current.index), true);
                },
                thumbs : {
                    autoStart : true
                },
                caption : function( instance, item ) {
                    return thisVue.imagem[item.index].serv +'<br>' + 'Data: ' + thisVue.imagem[item.index].ref.substr(0, 10).split('-').reverse().join('/');
                }
            });
        }
    }
</script>


<style scoped>

  .pag-header {
    height: 40px;
    width: 100%;
    background-image: url('/static/img/pag-header.png');
  }
</style>

<style lang="scss">
  .slick-prev:before, .slick-next:before {
    color: black;
    line-height: 0.5;
    font-size: 50px;
    color: #bebebe;
  }

  .slick-prev, .slick-next {
    z-index: 1;
  }

  .slick-prev {
    left: 1px;
  }

  .slick-next {
    right: 30px;
  }

  .slick-slide {
    height: 400px;
  }

  .slick-slide.fancybox-content{
    height: auto;
    float: none;
  }

  .slick-slide img {
    cursor: pointer;
    height: 400px;
  }

  .legenda {
    position: absolute;
    color: #fff;
    background: #00000061;
    padding: 10px;
    border-radius: 5px;
    bottom: 0;
  }

  .fancybox-thumbs__list a:before{
    border: 6px solid #f5911e;
  }
</style>





// WEBPACK FOOTER //
// src/components/detalhe-obra/DetalheObra.vue